import { Component, OnInit} from '@angular/core';
import { SeoService } from '@services/seo.service';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss']
})

export class FAQComponent implements OnInit {
    panelOpenState = false;
    constructor(
        private seoService: SeoService,
    ) { }

    ngOnInit() {
        this.seoService.set({
            title: 'Häufige Fragen (FAQ) | Spieloguide',
            description: 'Häufig gestellte Fragen rund um Spieloguide.',
            path: '/faq'
        });
    }
}
